<mat-card class="clientCarsCard">
  <div class="carsHeader">
    <div class="carsTitleRow">
      <div class="carsTitleWrap">
        <div class="carsTitle">Автомобили</div>
        <span class="carsCounter" *ngIf="client?.cars?.length">{{ carsCountLabel }}</span>
      </div>
      <button
        mat-flat-button
        color="primary"
        aria-label="Добавить автомобиль"
        matTooltip="Добавить автомобиль"
        (click)="createCar()"
      >
        <mat-icon>add</mat-icon> Автомобиль
      </button>
    </div>

    <mat-form-field appearance="outline" class="carsFilter">
      <mat-label>Фильтр</mat-label>
      <input matInput [formControl]="filterControl" placeholder="VIN или описание" />
      <button
        *ngIf="filterQuery"
        mat-icon-button
        matSuffix
        type="button"
        aria-label="Очистить фильтр"
        (click)="filterControl.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-icon *ngIf="!filterQuery" matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  <div class="actionError" *ngIf="error" role="alert">{{ error }}</div>
  <div class="carsViewport">
    <div class="carsList" *ngIf="filteredCars.length; else emptyCars">
      <article class="carRow" *ngFor="let car of filteredCars; trackBy: trackByCar">
        <div class="carIconWrap">
          <mat-icon>minor_crash</mat-icon>
        </div>

        <div class="carBody">
          <div class="carMeta">
            <div class="carVin" [title]="car.vin || 'VIN не указан'">
              {{ car.vin || 'VIN не указан' }}
            </div>
            <div class="carDescription" [title]="car.description || 'Описание не указано'">
              {{ car.description || 'Описание не указано' }}
            </div>
          </div>

          <div class="carDocumentActions">
            <button
              mat-stroked-button
              type="button"
              class="carDocumentAction carDocumentAction--selection"
              matTooltip="Создать подбор с этим клиентом и автомобилем"
              (click)="createPartsSelection(car)"
            >
              <mat-icon>assignment</mat-icon>
              <span>Подбор</span>
            </button>
            <button
              mat-stroked-button
              type="button"
              class="carDocumentAction carDocumentAction--order"
              matTooltip="Создать заказ с этим клиентом и автомобилем"
              (click)="createOrder(car)"
            >
              <mat-icon>add_shopping_cart</mat-icon>
              <span>Заказ</span>
            </button>
          </div>
        </div>

        <div class="carActions">
          <button
            mat-icon-button
            color="primary"
            aria-label="Редактировать автомобиль"
            matTooltip="Редактировать автомобиль"
            (click)="edit(car)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            aria-label="Удалить автомобиль"
            matTooltip="Удалить автомобиль"
            (click)="delete(car)" [disabled]="deletingId !== null"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </article>
    </div>

    <ng-template #emptyCars>
      <div class="carsEmptyState">
        <span *ngIf="filterQuery">По этому фильтру автомобили не найдены.</span>
        <span *ngIf="!filterQuery">У клиента пока нет автомобилей.</span>
      </div>
    </ng-template>
  </div>
</mat-card>
